define("TavanoTeam.NewsLetterForm.Router",
    ["NewsLetterForm.View"],

    function(NewsLetterFormView) {
    "use strict";

    var Router = Backbone.Router.extend({
        routes: {
            "newsletter-sign-up" : "newsletterSignUp"
        },

        initialize: function(options) {
            this.application = options.application;
        },
        newsletterSignUp: function() {

            var view = new NewsLetterFormView({
                application: this.application
            });
            view.showContent();
        }
    });

    return Router;

});
